import React from 'react';
import cn from 'classnames';

import {IModuleLinksProps, ModuleLinksStyleColor} from './IModuleLinks';

import styles from './ModuleLinks.module.scss';

const ModuleLinks = ({children, className, style, ref}: IModuleLinksProps) => {
	const variantWithSameSize =
		children?.props?.variant === ModuleLinksStyleColor.BLACK ||
		children?.props?.variant === ModuleLinksStyleColor.WHITE;

	return (
		<div
			ref={variantWithSameSize ? ref : null}
			className={cn(
				styles['module__links'],
				{[styles['module__links-maxWidth']]: variantWithSameSize && ref},
				className,
				'module__links',
			)}
			style={style}
		>
			{children}
		</div>
	);
};

export default ModuleLinks;
